const moment = require('moment-timezone');

const canModifyShowing = ({ start_time, completed_at, status }) => {
  const finished = ['Canceled', 'Completed'].includes(status);
  const pending = moment(start_time) > moment();
  return pending && !completed_at && !finished;
};

module.exports = { canModifyShowing };
